import __request__ from "routing/request";
export function checkCredentials(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.integrations/cloudtrail/check_credentials", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getAWSRegions(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.integrations/cloudtrail/getawsregions", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(JSONbody, setup_wizard = false, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.integrations/cloudtrail/inputs", JSONbody, { "setup_wizard": setup_wizard }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
